const manutencao_estrutura = {
  path: "/manutencao_estrutura_escola",
  redirect: "/manutencao_estrutura_escola",
  meta: {
    breadCrumb: "Gerenciamento de Matrícula - Parâmetros por Escola",
  },
  children: [
    {
      path: "/manutencao_estrutura_escola/novo",
      name: "manutencaoestruturaescola_novo",
      meta: {
        allowedPermissions: ["estrutura_escola_create"],
      },
      component: () =>
        import(
          "@/views/ManutencaoEstruturaParaEscola/ManutencaoEstruturaEscolaCad.vue"
        ),
    },
    {
      path: "/manutencao_estrutura_escola/edit/:id",
      name: "manutencaoestruturaescola_atualizar",
      meta: {
        allowedPermissions: ["estrutura_escola_edit"],
      },
      component: () =>
        import(
          "@/views/ManutencaoEstruturaParaEscola/ManutencaoEstruturaEscolaEdit.vue"
        ),
    },
    {
      path: "/manutencao_estrutura_escola",
      name: "manutencaoestruturaescola",
      meta: {
        allowedPermissions: ["estrutura_escola_list"],
      },
      component: () =>
        import(
          "@/views/ManutencaoEstruturaParaEscola/ManutencaoEstruturaEscolaHome.vue"
        ),
    },
  ],
};
export { manutencao_estrutura };
